import { render, staticRenderFns } from "./ShowNotificacaoData.vue?vue&type=template&id=c922251a&scoped=true&"
import script from "./ShowNotificacaoData.vue?vue&type=script&lang=js&"
export * from "./ShowNotificacaoData.vue?vue&type=script&lang=js&"
import style0 from "./ShowNotificacaoData.vue?vue&type=style&index=0&id=c922251a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922251a",
  null
  
)

export default component.exports